<script setup lang="ts">
// -------------------------------
// 🔹 Imports Vue et composables
// -------------------------------
import { toRaw, watchEffect } from 'vue';
import { useQuery } from '@tanstack/vue-query';

// -------------------------------
// 🔹 Imports composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Imports stores Pinia
// -------------------------------
import { useProductStore } from '@/store/product.store';

// -------------------------------
// 🔹 Imports utilitaires
// -------------------------------

// -------------------------------
// 🔹 Imports assets / refs / données
// -------------------------------
import {
  stepOneActive,
  stepTwoActive,
  descriptionPageProduct,
  arraysStepTwo,
  stepThreeActive,
  arraysStepThree,
  dynamicOptions,
  form_product_step_one,
  category_product,
  previewUrl,
  dynamicExtraOptions,
  stepFourActive,
  isUpdatedProduct,
} from '@/refs/product.refs';
import { useCategoryStore } from '@/store/category.store';
import { useCommerceStore } from '@/store/commerce.store';
import { useTaxeStore } from '@/store/taxe.stsore';

// -------------------------------
// 🔹 Imports Types
// -------------------------------

// -------------------------------
// 🔹 Props et emits instanciés
// -------------------------------

// -------------------------------
// 🔹 Stores instanciés
// -------------------------------
const productStore = useProductStore();
const categoryStore = useCategoryStore();
const commerceStore = useCommerceStore();
const taxeStore = useTaxeStore();
// -------------------------------
// 🔹 Récupération des commandes avec Vue Query
// -------------------------------
const {
  data: dataGetCommerces,
  isLoading: isLoadingGetCommerces,
  isError: isErrorGetCommerces,
  refetch: refectGetCommerces,
} = useQuery({
  queryKey: ['GetCommerces'],
  queryFn: () => commerceStore.getCommerces(),
});

const {
  data: dataGetTaxeStore,
  isLoading: isLoadingGetdataGetTaxeStore,
  isError: isErrorGetdataGetTaxeStore,
  refetch: refectGetTaxeStore,
} = useQuery({
  queryKey: ['GetTaxeStore'],
  queryFn: () => taxeStore.getTaxe(),
});
// -------------------------------
// 🔹 Toutes les fonctions
// -------------------------------
const HandleCheckedDesignation = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'takeaway';
  const index = arraysStepThree.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepThree.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepThree.value[index] = newItem;
    } else {
      arraysStepThree.value.push(newItem);
    }
  }
};
const HandleTaxeSecond = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'onsite';
  const index = arraysStepThree.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepThree.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepThree.value[index] = newItem;
    } else {
      arraysStepThree.value.push(newItem);
    }
  }
};

const HandleEanSecond = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'ean';
  const index = arraysStepThree.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepThree.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepThree.value[index] = newItem;
    } else {
      arraysStepThree.value.push(newItem);
    }
  }
};

const HandlerCommerce = (e: Event) => {
  const element = e.target as HTMLInputElement;
  const value = element.value.trim();
  const title = 'onsite';
  const index = arraysStepThree.value.findIndex((item) => item.title === title);

  if (value === '') {
    if (index !== -1) {
      arraysStepThree.value.splice(index, 1);
      //   console.log(${title}' supprimé du tableau (champ vide).`);
    } else {
    }
  } else {
    const newItem = { value: 1, title };
    if (index !== -1) {
      arraysStepThree.value[index] = newItem;
    } else {
      arraysStepThree.value.push(newItem);
    }
  }
};

const goToNextPage = () => {
  if (isUpdatedProduct.value) {
    stepThreeActive.value = false;
    stepOneActive.value = false;
    stepTwoActive.value = true;

    stepFourActive.value = false;
  } else {
    descriptionPageProduct.value =
      'Produit / Nouveau produit / Informations du produit / Ajouter des accompagnements/Pévisualisation';
    stepOneActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = false;
    stepFourActive.value = true;
  }
};

const HandleInscrement = () => {
  dynamicOptions.value.push({ name: '' });

  //   sateIncrement.value = sateIncrement.value + 1;
};

const HandleDecreInscrement = (index?: number) => {
  if (dynamicOptions.value.length <= 1) return;
  dynamicOptions.value.splice(index, 1);
};
const handleSubmit = () => {
  if (isUpdatedProduct.value) {
    stepOneActive.value = false;
    stepTwoActive.value = false;
    stepThreeActive.value = false;
    stepFourActive.value = true;
  } else {
    goToNextPage();
  }
};

// -------------------------------
// 🔹 Debugging (optionnel)
// -------------------------------
// watchEffect(() => {
//   console.log("Nombre d'enfants :", form_container?.childElementCount);
// });
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="w-full space-y-8">
      <!-- <TextInput
                @HandleTextInput="(e: Event) => HandleCheckedDesignation(e)"
                v-model="form_product_step_one.taxe_teakeaway"
                name="tva_takeaway"
                placeholder="Entrez la valeur de la TVA"
                type="text"
                id="tva_takeaway"
                label="Valeur de la TVA pour une commande à emporter"
                class="flex-1" /> -->

      <div class="flex flex-col gap-2">
        <label
          for="commerce"
          class="text-14px font-tt-medium-Normal leading-normal"
        >
          "Valeur de la TVA pour une commande sur place
          <span class="text-decroissance text-14px leading-normal">*</span>
        </label>

        <select
          id="Entrez la valeur de la TVA"
          v-model="form_product_step_one.taxte_onsite"
          @change="(e: Event) => HandleCheckedDesignation(e)"
          required
          class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
        >
          <option value="">Valeur de la TVA pour une commande sur place</option>

          <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
          <option v-for="value in dataGetTaxeStore?.data" :value="value?.id">
            {{ value.name }} , {{ value.rate }}%,{{ value.type }}
          </option>
        </select>
      </div>

      <div class="flex flex-col gap-2">
        <label
          for="commerce"
          class="text-14px font-tt-medium-Normal leading-normal"
        >
          Valeur de la TVA pour une commande à emporter
          <span class="text-decroissance text-14px leading-normal">*</span>
        </label>

        <select
          id="Entrez la valeur de la TVA"
          name="Entrez la valeur de la TVA"
          v-model="form_product_step_one.taxe_teakeaway"
          @change="(e: Event) => HandleCheckedDesignation(e)"
          required
          class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
        >
          <option value="">
            Valeur de la TVA pour une commande à emporter
          </option>

          <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
          <option v-for="value in dataGetTaxeStore?.data" :value="value?.id">
            {{ value.name }} , {{ value.rate }}%,{{ value.type }}
          </option>
        </select>
      </div>
      <div class="flex flex-col gap-2">
        <label
          for="commerce"
          class="text-14px font-tt-medium-Normal leading-normal"
        >
          Veuillez sélectionner un commerce associé
          <span class="text-decroissance text-14px leading-normal">*</span>
        </label>

        <select
          id="commerce"
          name="commerce_associé"
          v-model="form_product_step_one.SelectRestaurant"
          @change="(e: Event) => HandlerCommerce(e)"
          required
          class="border-border-input focus:border-primary-900 focus:ring-primary-900 box-border h-(--input-height) rounded-[10px] border px-3 py-1 outline-0 focus:ring-1"
        >
          <option value="">Veuillez sélectionner un commerce associé</option>

          <!-- Exemple de valeurs (à remplacer par ta liste dynamique) -->
          <option v-for="value in dataGetCommerces?.data" :value="value?.id">
            {{ value.designation }}
          </option>
        </select>
      </div>
      <TextInput
        @HandleTextInput="(e: Event) => HandleEanSecond(e)"
        v-model="form_product_step_one.ean"
        name="ean"
        placeholder="123456789012, 123456789013, 123456789014,..."
        type="text"
        id="ean"
        label="Entrez un ou  plusieurs  Ean séparés par des virgules pour ce produit et Chaque valeur dans EAN doit être un code EAN (European Article Number) valide."
        class="flex-1"
      />
    </div>

    <div class="flex flex-row items-end justify-end gap-4">
      <div @click="goToNextPage">
        <BaseButtonPrimary
          type="button"
          :label="isUpdatedProduct ? 'Page précédente' : 'Oublier cette étape'"
          style_of_btn="secondary_color_of_btn "
          class="text-grand-text"
        />
      </div>
      <BaseButtonPrimary
        type="submit"
        label="Sauvegarder et continuer"
        style_of_btn="primary_color_of_btn "
        class="text-white"
      />
    </div>
  </form>
</template>
